import { yup } from '@guiker/yup-util'

export const tenantApplicationById = yup.object({
  tenantApplicationId: yup.string().required(),
})
